class ReplayPlayer {
  pseudo = "";
  category = -1;
  chips = 0;
  chipsOnTable = 0;
  seat = 0;
  cards = [];
  current;
  eventType = "NONE";
  playing;
  atShowDown;
  showedCards;
  percentage = -1;

  static from(json) {
    let player = new ReplayPlayer();
    Object.assign(player, json);
    return player;
  }
}

const getRepositionedSeat = (seat, seats, preferredSeat = 0, mainSeat = 0) => {
  var diff = preferredSeat - mainSeat;
  var newSeat = seat;
  newSeat += diff;
  if (newSeat > seats) {
    newSeat = newSeat - seats;
  } else if (newSeat <= 0) {
    newSeat = newSeat + seats;
  }
  return newSeat;
};

export { ReplayPlayer, getRepositionedSeat };
